<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">{{ 'REGISTRATION' | translate }}</h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  @if (!isAwaitingSmsCheck) {
    <form [formGroup]="form" #formEl spellcheck="false">
      <div class="modal-body">
        <div class="tabs tabs--in-box">
          <div class="nav" id="nav-tab" role="tablist">
            @for (type of types; track type) {
              <a
                class="nav-item nav-link"
                role="tab"
                [class.active]="type === activeType"
                (click)="changeTab(type)"
                >{{ typesMap.get(type) | translate }}</a
              >
            }
          </div>
          <div class="tabs__line" aria-hidden="true"></div>
        </div>
        <div class="tab-content" @parent>
          @if (form.get('phone').enabled) {
            <div class="form-control" @fadeInOut>
              <label for="phone"
                >{{ 'PHONE_NUMBER' | translate }}
                <span class="text-danger"> *</span></label
              >
              <ngx-intl-tel-input
                [onlyCountries]="['by']"
                formControlName="phone"
                appAutofocus
                mobilePhone
                phonePrefix
                (ngModelChange)="
                  phone = $event ? $any($event).internationalNumber : ''
                "
                ngxTelInputPlaceholder
              ></ngx-intl-tel-input>
              <app-control-errors control="phone"></app-control-errors>
            </div>
          }
          @if (form.get('trn').enabled) {
            <div class="form-control" @fadeInOut>
              <label for="tpi-reg">{{ 'TPI' | translate }}</label>
              <input
                type="text"
                id="tpi-reg"
                formControlName="trn"
                placeholder="{{ 'TPI_PLACEHOLDER' | translate }}"
                appAutofocus
                [numbersOnly]="true"
                minlength="9"
                maxlength="9"
              />
              <app-unp-status [unp]="form.get('trn').value"></app-unp-status>
              <app-control-errors control="trn"></app-control-errors>
            </div>
          }
          <app-filial-selector
            formControlName="filial"
            [params]="{ login: 'true' }"
            [unp]="form.get('trn').value"
          >
            <app-control-errors control="filial"></app-control-errors>
          </app-filial-selector>
          <div class="form-control">
            <label for="password-reg">{{ 'PASSWORD' | translate }}</label>
            <div class="position-relative">
              <input
                type="password"
                id="password-reg"
                class="pr-5"
                formControlName="password"
                placeholder="{{ 'PASSWORD_PLACEHOLDER' | translate }}"
                maxlength="255"
                autocomplete="new-password"
                appPassword
              />
            </div>
            <app-password-validation
              [control]="form.get('password')"
            ></app-password-validation>
          </div>
          <div class="form-control">
            <label for="email-reg">{{ 'EMAIL' | translate }}</label>
            <div class="position-relative">
              <input
                type="email"
                id="email-reg"
                formControlName="email"
                placeholder="{{ 'EMAIL_PLACEHOLDER' | translate }}"
                maxlength="255"
              />
            </div>
            <app-control-errors control="email"></app-control-errors>
          </div>
          @if (form.get('captcha').enabled) {
            <div class="form-control">
              <app-captcha formControlName="captcha"></app-captcha>
              <app-control-errors control="captcha"></app-control-errors>
            </div>
          }
          <div class="form-control">
            <div class="checkbox">
              <input
                type="checkbox"
                id="terms_of_use_pa"
                formControlName="terms_of_use"
              />
              <label for="terms_of_use_pa" class="d-flex align-items-center">
                <div class="checkbox__el"></div>
                <div class="checkbox__desc">
                  <a
                    type="button"
                    class="checbox_tearms"
                    (click)="navigateToUserAgreement($event)"
                  >
                    {{ 'TERMS_OF_USE_LABEL' | translate }}
                  </a>
                </div>
              </label>
            </div>
            <app-control-errors control="terms_of_use"></app-control-errors>
          </div>
          <div class="form-control">
            <div class="checkbox">
              <input
                type="checkbox"
                id="is_accept_advertisement"
                formControlName="is_accept_advertisement"
              />
              <label
                for="is_accept_advertisement"
                class="d-flex align-items-center"
              >
                <div class="checkbox__el"></div>
                <div class="checkbox__desc">
                  @switch (activeType) {
                    @case ('individual') {
                      <p
                        class="checkbox_advertisement"
                        [innerHtml]="
                          'IS_ACCEPT_ADVERTISEMENT_INDIVIDUAL'
                            | translate
                            | safe: 'html'
                        "
                      ></p>
                    }
                    @case ('legal') {
                      <p
                        class="checkbox_advertisement"
                        [innerHtml]="
                          'IS_ACCEPT_ADVERTISEMENT_LEGAL'
                            | translate
                            | safe: 'html'
                        "
                      ></p>
                    }
                  }
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="text-center mb-3">
          <a class="pointer" (click)="toLogin()">{{
            'LOGIN_FOR_REGISTERED' | translate
          }}</a>
        </div>
        <app-control-errors></app-control-errors>
      </div>
      <div class="modal-footer">
        <app-loading-button
          [disabled]="isLoading || form.invalid"
          [loading]="isLoading"
          (handleClick)="sendRegistration()"
          type="submit"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'CONTINUE' | translate }}
        </app-loading-button>
      </div>
    </form>
  } @else {
    <form
      #formCode="ngForm"
      #formCodeEl
      (ngSubmit)="sendCode()"
      spellcheck="false"
    >
      <div class="modal-body">
        <!-- Enter sms code -->
        <p>
          {{ 'CODE_SENT_TO' | translate }}
          <span class="font-weight-medium">{{ phone }}</span>
        </p>
        <div class="form-control" @fadeInOut>
          <label for="code-reg">{{ 'SMS_CODE' | translate }}</label>
          <input
            type="text"
            name="code"
            id="code-reg"
            [(ngModel)]="code"
            placeholder="1 2 3 4"
            required
            mask="0 0 0 0"
            minlength="4"
            autocomplete="one-time-code"
            appAutofocus
          />
          <app-control-errors control="code"></app-control-errors>
        </div>
        <ul class="list-column text-center mb-3">
          <!-- <li>
          <ng-container [counter]="30"
            [interval]="1000"
            (value)="count = $event"
            #counter="counter">
            <button class="text-link"
              type="button"
              [disabled]="isResendingCode || count > 0"
              (click)="resendCode(); counter.restart()">{{ 'RESEND_CODE' | translate }} <span *ngIf="count > 0">({{ count }})</span></button>
            </ng-container>
          </li> -->
          <li>
            <a class="pointer" (click)="toLogin()">{{
              'LOGIN_FOR_REGISTERED' | translate
            }}</a>
          </li>
        </ul>
        <app-control-errors></app-control-errors>
      </div>
      <div class="modal-footer">
        <app-loading-button
          [disabled]="isLoading || (formCode.submitted && formCode.invalid)"
          [loading]="isLoading"
          (handleClick)="sendCode()"
          type="submit"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'CONTINUE' | translate }}
        </app-loading-button>
      </div>
    </form>
  }
</div>
